import React, { useState } from 'react'
import SearchStudents from './SearchStudents'
import { StudentInterface } from '../types/interface/student.interface'
import UploadCertificate from './UploadCertificate'

function UploaderWrapper() {
  const [selectedStudent, setSelectedStudent] =
    useState<StudentInterface | null>(null)
  const [courseName, setCourseName] = useState<string | null>('')

  return (
    <div className="w-full sm:max-w-xl max-w-[90%] h-3/4 flex flex-col items-center p-8 rounded-lg bg-secondary gap-10 overflow-auto">
      <span className="text-5xl text-primary font-semibold text-center">
        Upload Certificate
      </span>
      <div className="flex flex-col gap-10 w-full items-center">
        <SearchStudents
          selectedOption={selectedStudent}
          setSelectedOption={setSelectedStudent}
          courseName={courseName}
          setCourseName={setCourseName}
        />
        {selectedStudent && (
          <UploadCertificate
            student={selectedStudent}
            courseName={courseName}
            selectedOption={selectedStudent}
            setSelectedOption={setSelectedStudent}
          />
        )}
      </div>
    </div>
  )
}

export default UploaderWrapper
